// Shared helpers for the jewelry reports' Vendor(s)/Retailer(s) multi-select
// filters and the detail table's sort-column mapping (antd's camelCase
// dataIndex -> the backend's PascalCase sortColumnName).

import moment from "moment";

// Task 1706 (B1): prior-period totals for the KPI strip's trend arrow.
// Re-hits the report's own chart endpoint for an equal-length window ending
// the day before dataRangeFrom -- same window math as the diamond suite's
// priorPeriodLabel -- instead of adding a new backend endpoint. Returns a
// summed total (matching how each report already sums its own chart rows
// into TotalClicks), or null on failure so callers can render "no trend"
// rather than a fake 0% change.
export const fetchPriorPeriodTotalClicks = (fetchFn, buildParams, dataRangeFrom, dataRangeTo, countField = "count", getRows = (data) => data?.Table) => {
  const from = moment(dataRangeFrom);
  const to = moment(dataRangeTo);
  const durationDays = to.diff(from, "days");
  const priorTo = from.clone().subtract(1, "days");
  const priorFrom = priorTo.clone().subtract(durationDays, "days");
  return fetchFn(buildParams(priorFrom.format("YYYY-MM-DD"), priorTo.format("YYYY-MM-DD")))
    .then((response) => {
      const rows = response.data.message === "Success" ? getRows(response.data.responseData) : null;
      if (!rows) return 0;
      return rows.reduce((sum, row) => sum + Number(row[countField] || 0), 0);
    })
    .catch(() => null);
};

// The Vendor/Retailer <Select> options are keyed "dealerID|dealerCompany" so
// the label survives round-tripping through antd's multi-select value array;
// this strips it back down to a plain id (or "0" for the synthetic "All").
export const extractDealerId = (value) => {
  if (value === 0 || value === "0") return "0";
  if (typeof value === "string" && value.includes("|")) {
    return value.split("|")[0];
  }
  return value.toString();
};

export const extractDealerIds = (values) => {
  if (!values || values.length === 0) return [];
  return values.map(extractDealerId);
};

const SORT_COLUMN_MAP = {
  userIPAddress: "UserIPAddress",
  vendorName: "VendorName",
  retailerName: "RetailerName",
  collectionNew: "CollectionNew",
  category: "Category",
  date: "Date",
  styleNumber: "StyleNumber",
  metalType: "MetalType",
  metalColor: "MetalColor",
  price: "Price",
};

export const mapSortColumn = (dataIndex) => SORT_COLUMN_MAP[dataIndex] || "Date";
